<template>
    <okraina-sheet v-model:visible="visibleInternal">
        <template v-slot:body>
            <div class="okraina-order-shipment">
                <div class="sheet-title">Выберите способ доставки</div>
                <div class="items">
                    <div class="item" v-for="item in items" :key="item.ID">
                        <okraina-radio :label="item.NAME" :value="item.ID" v-model="value"
                            :description="(item.PRICE > 0 ? 'Стоимость ' + item.PRICE + 'р. <br/>' : '') + item.DESCRIPTION" />

                    </div>
                </div>

                <div class="btn btn-block btn1" @click="apply">Принять</div>
            </div>
        </template>
    </okraina-sheet>
</template>

<script>
import okrainaSheet from "@/components/sheet.vue";
import okrainaRadio from "@/components/controls/radio.vue";

export default {
    name: "okraina-order-shipment",
    components: {
        okrainaSheet,
        okrainaRadio
    },
    emits: ["update:visible", "update:modelValue"],
    data() {
        return {
            visibleInternal: this.visible,
            watchVisible: false,
            value: this.modelValue
        }
    },
    props: {
        visible: {
            type: Boolean,
            default() {
                return false;
            },
        },
        items: {
            type: Array,
            default() {
                return [];
            },
        },
        modelValue: {
            type: [Number, String],
            default() {
                return 0;
            },
        },

    },
    watch: {
        visibleInternal: function (newVal) {
            this.$emit("update:visible", newVal);
        },
        visible: function () {
            this.visibleInternal = this.visible;
            if (this.visible) {
                this.value = this.modelValue;
            }
        },
        modelValue: function () {
            this.value = this.modelValue;
        }
    },

    methods: {

        apply() {
            this.$emit("update:modelValue", this.value);
            this.visibleInternal = false;
        }
    }
}

</script>

<style lang="scss">
.okraina-order-shipment {
    .item {
        margin-bottom: 10px;
    }

    .okraina-radio {
        .message {
            font-weight: 600;
        }

        .description {
            color: var(--color-text-dark);
            font-weight: 500;
            margin-top: 5px;

        }
    }


    .items {
        margin-bottom: 30px;
    }
}
</style>
